export default __webpack_public_path__ + "static/media/templo.42f7e6bf.png";